/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';

export const Wrapped = (ControlComponent, ExperimentComponent) => {
    class VersionWrapper extends Component {
        constructor(props) {
            super(props);
            this.state = { renderExperiment: props.experiment };
        }

        render() {
            return (
                <div>
                    { this.state.renderExperiment ?
                            ExperimentComponent :
                            ControlComponent
                    }
                </div>
            );
        }
    }

    function mapStateToProps(state) {
        return {
            experiment: state.navigation.get('experiment'),
        };
    }

    return connect(mapStateToProps)(VersionWrapper);
};




// WEBPACK FOOTER //
// ./src/components/wrapper/VersionWrapper.jsx